import { AfterContentInit, Directive, ElementRef, inject, OnDestroy, OnInit } from '@angular/core';

import { KROS_FORM_FIELD_HOST } from '../kros-form-field/kros-form-field.token';

@Directive({
  selector: '[krosSuffix], i[krosIconSuffix]',
  standalone: false,
})
export class KrosSuffix implements OnInit, OnDestroy, AfterContentInit {
  readonly #formFieldSuffixClass = 'kros-form-field-infix-right';
  readonly #formFieldSuffixMultipleClass = 'kros-form-field-infix-right-multiple';

  #formField = inject(KROS_FORM_FIELD_HOST);
  #elementRef = inject(ElementRef);

  ngOnInit(): void {
    this.#formField.addClass(this.#formFieldSuffixClass);
  }

  ngAfterContentInit(): void {
    const suffixContainer = this.#elementRef.nativeElement.closest('.kros-form-field-icon-suffix');
    if (suffixContainer) {
      const iconCount = suffixContainer.children.length;
      if (iconCount > 1) {
        this.#formField.addClass(this.#formFieldSuffixMultipleClass);
      }
    }
  }

  ngOnDestroy(): void {
    this.#formField.removeClass(this.#formFieldSuffixClass);
    this.#formField.removeClass(this.#formFieldSuffixMultipleClass);
  }
}
